module.exports = __webpack_public_path__ + "static/img/cstSer_bg_07.89357b85.svg";